// extracted by mini-css-extract-plugin
module.exports = {"button":"menu-trigger-button_button__A6IJT","button-name":"menu-trigger-button_button-name__4WN3R"};